import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { useEffect } from 'react';
import useFeatureFlag from './useFeatureFlag';

export default function EnterKeyListener(
  isButtonEnabled: boolean,
  callbackToNextPage: Function,
  isWithFlagEvaluation: boolean = false
) {
  const returnKeyEvaluation = useFeatureFlag(CLIENT_FEATURE_FLAGS.GROWTH_RETURN_KEY_TO_ADVANCE);
  const isWithReturnKey = returnKeyEvaluation?.value === 2;

  useEffect(() => {
    if (isWithFlagEvaluation && !isWithReturnKey) {
      return undefined;
    }

    const listener = (event: any) => {
      if (
        (event.key === 'Enter' || event.key === 'NumpadEnter') &&
        isButtonEnabled &&
        event.target.tagName !== 'TEXTAREA'
      ) {
        callbackToNextPage();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [isButtonEnabled]);
}
